/**
 * Gap size for flex components
 * @typedef {('gap-4' | 'gap-8' | 'gap-12' | 'gap-16' | 'gap-24' | 'gap-32' | 'gap-dynamic')} Gap
 */

/**
 * @type {Record<string, Gap>}
 */
export const Gap = {
  Space4: 'gap-4',
  Space8: 'gap-8',
  Space12: 'gap-12',
  Space16: 'gap-16',
  Space24: 'gap-24',
  Space32: 'gap-32',
  Dynamic: 'gap-dynamic', // Uses the variable --layout--gap-width value from /ui-components/components/responsive-layout/styles.less
};
